import mitt from 'mitt'
const eventsBus = mitt()
export default eventsBus
